export default "__VITE_ASSET__C8Tb8NZY__"